import styled from "styled-components";

const StyledNav =  styled.div` 
      background-color: rgba(6, 214, 160, 1);
      padding: 1rem;
      color: white;
      text-decoration: none;
      color: #fff;

     nav {
          text-decoration: none;
          color: #fff;
     }

     .navbar__color {
          text-decoration: none;
          color: #fff;
     }


     h2 {
          margin-bottom: 1rem;
          font-size: large;
          font-family: 'Courier New', Courier, monospace;
     }


     ul {
          list-style: none;
     }


     li {
          margin-bottom: 1rem;
     }


@media(min-width: 768px) {
     nav {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
     }

     h2 {
        margin: 0;
     }

     ul {
        display: flex;
        flex-direction: row;
     }


     li {
        margin: 0 1rem;

     }
}
     
`;

export default StyledNav;